package com.milta.core.network

/**
 * Generic paginated response envelope (MIL-52 — first endpoints to need real pagination on the web
 * dashboard: `GET /routes/history` and `GET /routes/{routeId}/proofs`). Domain-level counterpart of
 * `com.milta.feature.route.data.remote.dto.PagedResultDto` — lives in `core.network` rather than a
 * single feature package since it's a wire-protocol shape, not tied to any one domain entity, and
 * future paginated endpoints (any feature) can reuse it as-is.
 */
data class PagedResult<T>(
    val items: List<T>,
    val page: Int,
    val pageSize: Int,
    val totalCount: Int,
) {
    /** At least 1 once there is any data, 0 when [totalCount] is 0 (nothing to paginate at all). */
    val totalPages: Int
        get() = if (pageSize <= 0 || totalCount <= 0) 0 else (totalCount + pageSize - 1) / pageSize
}
